import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Col,
} from 'reactstrap';
import { getStateCodes } from '../actions/ProposalsEditor';
import Location from '../components/Location/index';
import './addressValidation.css';
const E911AddressModal = ({
  isOpen,
  onCancel,
  data,
  onUpdate,
  selectedNumberTitle,
  onRemoveAddress,
  port,
  openValidationModal,
  modalCloseValidation,
  suggestedData,
  isReadOnly,
}) => {
  const [state, setState] = useState(data);
  const [locationState, setLocationState] = useState({});
  const [tempAddress, setTempAddress] = useState({});
  const dispatch = useDispatch();

  const dataSuggested = {
    callername: tempAddress?.callername || "",
    dn: tempAddress?.dn || "",
    address1: suggestedData?.address1 || "",
    address2: tempAddress?.address2 || "",
    city: tempAddress?.city || "",
    state: tempAddress?.state || "",
    zip: tempAddress?.zip || "",
    country: tempAddress?.country || ""
  };

  const handleChange = e => {
    setState({ ...state, [e.currentTarget.name]: e.currentTarget.value });
  };

  useEffect(() => {
    dispatch(getStateCodes(localStorage.getItem('jwtToken')));
  }, []);

  const removeButton = (
    <Button color="primary" onClick={onRemoveAddress}>
      Remove Address
    </Button>
  );

  const getLocationInfo = ev => {
    if (ev) {
      setLocationState({
        address1: ev?.address,
        address2: ev?.address2,
        city: ev?.city,
        state: ev?.state,
        zip: ev?.zip,
        country: ev?.country,
      });
    }
  };
  return (
    <>
    <Modal isOpen={isOpen}>
      <ModalHeader close={port?.e911Enabled && removeButton}>{selectedNumberTitle}</ModalHeader>
      <ModalBody>
        <FormGroup row>
          <Label for="callername" sm={4}>
            Caller Name:
          </Label>
          <Col sm={12}>
            <Input
              required
              type="text"
              name="callername"
              placeholder="Caller Name..."
              defaultValue={data?.callername}
              onChange={handleChange}
            />
          </Col>
        </FormGroup>
        <Location
            disabled={false}
            boxDbLocation={state?.length ? state : data}
            getLocationInfo={getLocationInfo}
            latLang={false}
            address2={true}
        />
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={isReadOnly}
          onClick={() => {
            const obj = state || data;
            obj['dn'] = selectedNumberTitle;
            onUpdate({...obj, ...locationState});
            setTempAddress({...obj, ...locationState})
          }}
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>

      <Modal isOpen={openValidationModal} centered modalClassName="address-validation-modal">
        <ModalHeader className="border-0 flex-column align-items-start">
          <div className="av-number-left">{tempAddress?.dn}</div>
          <div className="w-100 text-center">
            <h2 className="av-title-center">ADDRESS VALIDATION</h2>
          </div>
        </ModalHeader>
        <div className="av-divider" />
        <ModalBody className="text-center">
          <div className="av-address-block">
            <h5 className="av-subtitle">ORIGINAL ADDRESS</h5>
            <p>
              {tempAddress?.address1}, {tempAddress?.address2}<br />
              {tempAddress?.city}, {tempAddress?.state} {tempAddress?.zip}<br />
              {tempAddress?.country}
            </p>
          </div>
          <div className="av-address-block">
            <h5 className="av-subtitle">SUGGESTED ADDRESS</h5>
            <p>
            <p>
                {suggestedData?.address1}
                {suggestedData?.address2 && `, ${suggestedData.address2}`}
                , {suggestedData?.city}<br />
                {suggestedData?.state} {suggestedData?.zip} {suggestedData?.country}
              </p>
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex flex-column align-items-center">
          <Button color="primary" onClick={()=>onUpdate(dataSuggested,true)}>
          USE SUGGESTED
        </Button>
          <Button outline color="secondary" onClick={modalCloseValidation}>
          Cancel
        </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default E911AddressModal;
